export const isRealmValid = (realm: string) => /^[a-zA-Z0-9-]*$/.test(realm);
